// extracted by mini-css-extract-plugin
export default {"confirmButton":"ScheduleAppointmentContainer_confirmButton__mArQ-","selectedSpotLabel":"ScheduleAppointmentContainer_selectedSpotLabel__qX0O2"};